import React from 'react';
import { Award, ShieldCheck, Clock, FileCheck } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const iconMap = {
  award: Award,
  'shield-check': ShieldCheck,
  clock: Clock,
  'file-check': FileCheck
};

export const WhyChooseUs = () => {
  const { t } = useLanguage();
  
  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Side - Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://customer-assets.emergentagent.com/job_gearbox-shop/artifacts/skp0elwt_1000159600.jpg"
                alt="Façade du garage ESBLY AUTO - Bosch Car Service"
                className="w-full h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/30 to-transparent"></div>
            </div>
            
            {/* Stats Badge */}
            <div className="absolute -bottom-6 -right-6 bg-red-600 text-white rounded-2xl p-6 shadow-xl">
              <div className="text-4xl font-bold mb-1">{t.whyChooseUs.badge}</div>
              <div className="text-sm text-red-100">{t.whyChooseUs.badgeText}</div>
            </div>
          </div>

          {/* Right Side - Content */}
          <div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-800 mb-6">
              {t.whyChooseUs.title}
            </h2>
            <p className="text-lg text-slate-600 mb-10 leading-relaxed">
              {t.whyChooseUs.description}
            </p>

            {/* Features */}
            <div className="space-y-6">
              {t.whyChooseUs.features.map((feature, index) => {
                const iconKey = ['award', 'shield-check', 'clock', 'file-check'][index];
                const IconComponent = iconMap[iconKey] || Award;
                
                return (
                  <div 
                    key={index}
                    className="flex gap-4 group"
                  >
                    {/* Icon */}
                    <div className="flex-shrink-0 w-14 h-14 bg-red-100 rounded-lg flex items-center justify-center group-hover:bg-red-600 transition-colors duration-300">
                      <IconComponent 
                        className="text-red-600 group-hover:text-white transition-colors duration-300" 
                        size={28} 
                      />
                    </div>
                    
                    {/* Content */}
                    <div>
                      <h3 className="text-xl font-bold text-slate-800 mb-2">
                        {feature.title}
                      </h3>
                      <p className="text-slate-600 leading-relaxed">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
